import { INVOICE_STATUS_LABELS, INVOICE_STATUS_VALUES } from '@/lib/invoice'
import { EMPTY_DATE_RANGE, PERIOD_CHIP_KEY, getPeriodChipLabel, hasDateRange, parseDateRange, writeDateRange } from '@/lib/filters'
import type { DateRange } from '@/lib/filters'
import type { InvoiceStatus } from '@/api/types'

export type InvoiceStatusFilter = '' | InvoiceStatus

export interface InvoiceFacetFilters {
  status: InvoiceStatusFilter
  period: DateRange
}

export interface InvoiceFacetChip {
  key: string
  label: string
  withoutChip: InvoiceFacetFilters
}

export const STATUS_PARAM = 'status'
export const STATUS_GROUP_LABEL = 'Status'

export function parseInvoiceStatus(value: string | null): InvoiceStatusFilter {
  const match = INVOICE_STATUS_VALUES.find((status) => status === value)

  return match ?? ''
}

export function parseInvoiceFacetFilters(params: URLSearchParams): InvoiceFacetFilters {
  return { status: parseInvoiceStatus(params.get(STATUS_PARAM)), period: parseDateRange(params) }
}

export function writeInvoiceFacetFilters(params: URLSearchParams, filters: InvoiceFacetFilters): void {
  params.delete(STATUS_PARAM)

  if (filters.status !== '') {
    params.set(STATUS_PARAM, filters.status)
  }

  writeDateRange(params, filters.period)
}

export function countInvoiceMenuFacets(filters: InvoiceFacetFilters): number {
  if (filters.status === '') {
    return 0
  }

  return 1
}

export function toggleInvoiceStatus(filters: InvoiceFacetFilters, status: InvoiceStatus): InvoiceFacetFilters {
  if (filters.status === status) {
    return { ...filters, status: '' }
  }

  return { ...filters, status }
}

export function listInvoiceFacetChips(filters: InvoiceFacetFilters): InvoiceFacetChip[] {
  const chips: InvoiceFacetChip[] = []

  if (filters.status !== '') {
    chips.push({
      key: STATUS_PARAM,
      label: `${STATUS_GROUP_LABEL}: ${INVOICE_STATUS_LABELS[filters.status]}`,
      withoutChip: { ...filters, status: '' }
    })
  }

  if (hasDateRange(filters.period)) {
    chips.push({ key: PERIOD_CHIP_KEY, label: getPeriodChipLabel(filters.period), withoutChip: { ...filters, period: EMPTY_DATE_RANGE } })
  }

  return chips
}
